/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Rag_Internal_Only_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "The AI is now restricted to your organisation's linked knowledge spaces. Web search and external sources are disabled." |
*
* @param {Audit_Details_Rag_Internal_Only_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_rag_internal_only_enabled_desc = /** @type {((inputs?: Audit_Details_Rag_Internal_Only_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Rag_Internal_Only_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI ist jetzt auf die verlinkten Wissensspaces Ihrer Organisation beschränkt. Websuche und externe Quellen sind deaktiviert.")
	return /** @type {LocalizedString} */ ("The AI is now restricted to your organisation's linked knowledge spaces. Web search and external sources are disabled.")
});